/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { appState, setAlert, setLoading } from "../../slices/appSlice";
import { ALERT_FAIL,} from "../../app/constantes";
import { getDocumentosCobros, getEntidadDataCurso, getFacturasByConvocatoria, postPdfFactura, postPdfFacturaCurso } from "../../services/cobro";
import InputComp from "../generales/inputComponent";
import { getDocument } from "../../services/entidad";

export const initialForm = {
    idValue: {
        value: '',
        required: false,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
}
  

export default function ModalRecuperarPdf({modalData, setModalData}) {
    const dispatch = useDispatch();
    const appSt = useSelector(appState);
    const [facturas, setFacturas] = useState(null);
    const [form, setForm] = useState(JSON.parse(JSON.stringify(initialForm)));
    const [idValue, setIdValue] = useState(null);

    /**
     * Cerramos modal
     */
    const closeModal = () => {
        setModalData({
            show: false,
            data: null
        })
    }


    /**
     * Solicitamos factura
     */
    const handleSubmit = async (data) => {
        try {
            dispatch(setLoading(true));
            let xml = null
            const cobro = facturas.find((item) => Number(item[idValue]) === Number(form.idValue.value))
            const isCurso = modalData.data.idRegistroConvocatoria ? false : true
            if (!isCurso) {
                const resp = await getDocumentosCobros({
                    ...appSt.serviceData,
                    idCobroAplicado: cobro.idCobroAplicado,
                    cveTipoDocumento: 'DOCUMENTOFACTURA'
                })
                xml = resp.find(item => {
                    const name = item.idContent.toLowerCase()
                    return name.includes("xml")
                })
            } else if (isCurso) {
                xml = cobro
            }

            if (xml) {
                const data = {
                    ...appSt.serviceData,
                    idEntidad: modalData.data.idEntidad,
                    idContent: xml.idContent
                }

                const docResp = await getDocument(data);
                let pdf = null
                if (!isCurso) {
                    pdf = await postPdfFactura({
                        ...appSt.serviceData, body: {
                            xmlBase64: docResp.payload.base64,
                            idCobroRegistroConvocatoria: cobro.idCobroRegistroConvocatoria,
                            idAreaCemefi: appSt.serviceData.area,
                            idEntidad: cobro.idEntidad
                        }
                    })
                } else {
                    pdf = await postPdfFacturaCurso({
                        ...appSt.serviceData, body: {
                            xmlBase64: docResp.payload.base64,
                            idCobroCurso: cobro.isCobroCurso,
                            idAreaCemefi: appSt.serviceData.area,
                            idEntidad: cobro.idEntidad
                        }
                    })
                }
                const type = 'data:application/pdf'
                const file64 = pdf.archivoPDF;
                const linkSource = `${type};base64,${file64}`;
                const downloadLink = document.createElement('a');
                const fileName = "Factura";

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click()
            } else {
                dispatch(setLoading(false));
                dispatch(setAlert({
                    show: true,
                    message: "No se pudo obtener el pdf de la factura",
                    type: ALERT_FAIL
                }))  
            }

            dispatch(setLoading(false));

        } catch (error) {
            console.error(error)
            dispatch(setLoading(false));
            dispatch(setAlert({
                show: true,
                message: "No se pudo obtener el pdf de la factura",
                type: ALERT_FAIL
            }))   
        }   
    }

    const getData = async () => {
        dispatch(setLoading(true))
        try {
            let resp
            if (modalData.data.idRegistroConvocatoria) {
                setIdValue("idCobroAplicado")
                resp = await getFacturasByConvocatoria({
                    ...appSt.serviceData,
                    idRegistroConvocatoria: modalData.data.idRegistroConvocatoria
                })
            } else if (modalData.data.idEntidad) {
                setIdValue("isCobroCurso")
                resp = await getEntidadDataCurso({
                    ...appSt.serviceData,
                    idEntidad: modalData.data.idEntidad
                })
            }
            const array = []
            resp.payload.forEach((item) => {
                const exist = array.find((i) => i.folio === item.folio && i.serie === item.serie)
                if (!exist) {
                    array.push(item)
                }
            })
            setFacturas(array)
            dispatch(setLoading(false))
            
        } catch (error) {
            console.error(error)
            dispatch(setLoading(false))
            
        }
    } 

    useEffect(() => {
        if (modalData && modalData.data) {
            getData()
        }
    }, [modalData])    

    return (
        <div className={modalData.show ? 'modal-wrapper active' : 'modal-wrapper'}>
            <div className="modal recuperar-factura">
                <div className="head">
                    <h3>Recuperar PDF</h3>
                    <button onClick={closeModal}>
                        x
                    </button>
                </div>
                <div className="content">
                    <div className="input">
                        {facturas && idValue && <>
                            <InputComp label="Factura" name="idValue" type="select" form={form} setForm={setForm} catalogos={facturas} catalogoValue={idValue} catalogoLabel={'folio'} secundaryLabel={'serie'} />
                            <button disabled={form.idValue.value === ""} onClick={handleSubmit}>Recuperar PDF</button>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}